import { useState } from 'react';
import './device-details.styles.scss';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';

import CircularProgressLoader from '@lifepowr/components/src/components-shared/circular-progress-loader-component/circular-progress-loader.component';

import { API } from 'Amplify';
import { AccountStatus } from '@lifepowr/components/src/utils/account-status';

export function LinkPart(props: any) {
  const { accountStatus, email, userMode, width, thingName } = props;
  const [open, setOpen] = useState(false);
  const [linkEmail, setLinkEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [, setError] = useState('');

  const emailChange = (ev: any) => {
    setLinkEmail(ev.target.value);
  };

  const submit = async (_ev: any, type = 'link') => {
    const regex = / /gi;
    const processedEmailNoWhite = linkEmail.replace(regex, '');
    const processedEmailLowerCase = processedEmailNoWhite.toLowerCase();

    // Need to find way to not send emails
    const body = { email: processedEmailLowerCase /* noComms: true */ };

    if (type === 'unlink') {
      const r = window.confirm('Are you sure you want to unlink this account?');
      if (!r) {
        return 0;
      }
    }
    setLoading(true);
    try {
      if (type === 'link') {
        await API.post('IO_API', `/devices/${thingName}/link`, { body });
      } else if (type === 'unlink') {
        await API.del('IO_API', `/devices/${thingName}/link`, { body });
      }
      setError('');
      setLinkEmail('');
    } catch (e: any) {
      const errBody = e?.response?.data;
      console.log('ERROR', e.response.data, errBody, e.response);
      window.alert(`ERROR: ${e.response.data}`);
      setError(errBody ? errBody : `${e}`);
    }
    setOpen(false);
    setLoading(false);
  };

  if (loading) {
    return <CircularProgressLoader />;
  }

  return (
    <>
      <Typography variant="h5"> Linked Account </Typography>
      <div>
        <Box
          pb={1}
          display="flex"
          gap={0.5}
          alignItems="center"
        >
          <AccountStatus status={accountStatus} />
          {email ? `Current linked account email: ${email}` : 'Device not linked to an account'}
          {!userMode ? (
            <Button
              onClick={() => {
                email ? submit({}, 'unlink') : setOpen(true);
              }}
            >
              {email ? 'Unlink account' : 'Link Account'}
            </Button>
          ) : null}
        </Box>

        <Dialog
          fullWidth
          maxWidth={width}
          open={open}
          onClose={() => setOpen(false)}
        >
          <DialogTitle>Link user account</DialogTitle>
          <DialogContent>
            <TextField
              value={linkEmail}
              onChange={emailChange}
              label="Account email"
            />
          </DialogContent>
          <DialogActions>
            <Button
              disabled={loading}
              onClick={submit}
            >
              {loading ? 'Loading . . .' : 'Submit'}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
}
